import { render, staticRenderFns } from "./certificationLetterTab.vue?vue&type=template&id=23ad983b&scoped=true&"
import script from "./certificationLetterTab.vue?vue&type=script&lang=js&"
export * from "./certificationLetterTab.vue?vue&type=script&lang=js&"
import style0 from "./certificationLetterTab.vue?vue&type=style&index=0&id=23ad983b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ad983b",
  null
  
)

export default component.exports